<template>
    <div>
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <colgroup>
                <col style="width: 17%;" />
                <col style="width: 17%;" />
                <col style="width: 17%;" />
                <col style="width: 45%;" />
                <col style="width: 4%;" />
            </colgroup>
            <b-thead>
                <b-tr>
                    <b-th>Date:</b-th>
                    <b-th>Starting Balance:</b-th>
                    <b-th>Ending Balance:</b-th>
                    <b-th>Note:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(cash, index) in cashes" :key="index">
                    <b-td class="text-nowrap">
                        {{ _carbonDateDisplay(cash.date) }}
                    </b-td>
                    <b-td>
                        {{ _toCurrency(cash.start_amount) }}
                    </b-td>
                    <b-td>
                        {{ _toCurrency(cash.end_amount) }}
                    </b-td>
                    <b-td v-html="convertNewLineToBreak(cash.description)">
                    </b-td>
                    <b-td>
                        <b-dropdown
                            v-if="
                                _hasAccess('billing.cash.update') ||
                                _hasAccess('billing.cash.delete')
                            "
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            right
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>

                            <b-dropdown-item
                                v-if="_hasAccess('billing.cash.update')"
                                href="#"
                                @click="openEditModal(cash)"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Reconciliation
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="_hasAccess('billing.cash.delete')"
                                href="#"
                                @click="openDeleteModal(cash)"
                            >
                                <i class="cus-delete"></i>
                                Delete Reconciliation
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="cashes.length === 0">
                    <b-td colspan="5">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getCashes"
        />
        <!-- // FOR EDIT AND DELETE MODAL COMPONENT -->
        <create-update-cash-reconciliation
            ref="createUpdateCashReconciliation"
            @reload="reloadRelated"
        />

        <modal-delete-cash
            modal-ref="modalDeleteCash"
            ref="modalDeleteCash"
            @reload="reloadRelated"
        />
    </div>
</template>

<script>
/**
 * @name CashReconciliationList
 * @description List of cash reconciliation
 * @see apps/application/views/staff/billing/sub/cash/list.php
 * @see apps/application/views/staff/billing/sub/navbar.php
 * @see apps/assets/js/module/billing/cash.js
 * @see apps/application/views/staff/billing/sub/cash/create_update.php
 */
import Loader from "@/components/elements/loader-list";
import BillingCashServices from "@/services/billing/billing-cash";
import CreateUpdateCashReconciliation from "@/components/billing-cash/create-update";
import ModalDeleteCash from "@/components/billing-cash/modal-delete-cash";

export default {
    mixins: {},
    components: {
        Loader,
        CreateUpdateCashReconciliation,
        ModalDeleteCash
    },
    props: {},
    data() {
        return {
            isLoading: false,
            cashes: [],
            selectedRefund: {},
            selectedClientname: null,
            meta: null
        };
    },
    mounted() {
        this.getCashes();
    },
    methods: {
        openEditModal(cash) {
            this.selectedCash = cash;
            let date = this._fromDateCarbon(cash.date).toFormat("X");

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () =>
                    this.$refs.createUpdateCashReconciliation.open(cash),
                onError: message => this._message(message, "danger")
            });
        },
        openDeleteModal(cash) {
            this.selectedCash = cash;
            let date = this._fromDateCarbon(cash.date).toFormat("X");

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () => this.$refs.modalDeleteCash.open(cash),
                onError: message => this._message(message, "danger")
            });
        },
        reloadRelated() {
            this.getCashes();
        },
        getCashes(page = 1) {
            let self = this;
            self.cashes = [];
            self.isLoading = true;
            BillingCashServices.getCash(page, self.PER_PAGE)
                .then(res => {
                    self.cashes = res.data;
                    self.meta = {
                        lastPage: res.last_page,
                        currentPage: res.current_page,
                        total: res.total,
                        perPage: res.per_page
                    };
                })
                .catch(error => {
                    this._message("Error : Unable to get cash list", "danger");
                    this.isLoading = false;
                    console.error(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        }
    }
};
</script>
